const POINTS: string[] = [
  "Guided Canvas build across all six layers — Source, Success, Safety, Steering, Switch, Sharpen.",
  "Challenges vague answers and flags gaps between layers.",
  "Produces board-ready governance documents at the end.",
  "Quarterly review reminders keep your Canvas current.",
  "Built for business leaders, not developers.",
];

export function WhatYouGet() {
  return (
    <section className="lp-benefits" aria-labelledby="benefits-heading">
      <h2 className="lp-benefits__heading" id="benefits-heading">
        What you get
      </h2>
      <ul className="lp-benefits__list">
        {POINTS.map((p) => (
          <li key={p} className="lp-benefits__item">
            {p}
          </li>
        ))}
      </ul>
    </section>
  );
}
